export default __webpack_public_path__ + "static/media/Nes.2daf9e3b.png";